const RevcellaDetailSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        {/* メインタイトル */}
        <div className="text-center mb-16 md:mb-20">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark-gray mb-6">
            Revcella（リブセラ）
          </h2>
          <p className="text-lg md:text-xl text-gold font-semibold mb-4">
            進化型フェイシャル・スカルプトリートメント
          </p>
          <p className="text-medium-gray leading-relaxed max-w-3xl mx-auto text-sm md:text-base">
            美容医療からヒントを得た「エステティックプラズマ」を用いた最新理論の美容機器。<br className="hidden md:block" />
            従来のトリートメントでは不足を補うばかりの対処的ケアでしたが、<br className="hidden md:block" />
            リブセラは肌老化の根本的原因に視点をおいた再生予防的トリートメントが可能です。
          </p>
        </div>

        {/* エステティックプラズマとは */}
        <div className="mb-20 md:mb-28">
          <div className="bg-gradient-to-br from-light-gold to-beige rounded-3xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-6 text-center">
              エステティックプラズマとは？
            </h3>
            <div className="space-y-6 text-medium-gray leading-relaxed">
              <p className="text-sm md:text-base">
                プラズマとは、固体・液体・気体いずれでもない物質の<span className="font-bold text-gold">第4の状態</span>のことを言います。
              </p>
              <p className="text-sm md:text-base">
                宇宙の質量の99%以上はプラズマで構成されており、雷やオーロラもプラズマの一種です。近年様々な分野で注目されているプラズマ機器の理論をもとに、独自の技術を組み合わせ開発をおこない、色素や水分に反応しないため効率よく深部へのアプローチが可能になりました。
              </p>
              <p className="text-sm md:text-base">
                エステティックプラズマ特有の様々な効果で従来の機器、コスメでは不可能だった<span className="font-bold text-gold">「真のエイジングケア」</span>へと導きます。
              </p>
            </div>
          </div>
        </div>

        {/* リブセラの3つのポイント */}
        <div className="mb-20 md:mb-28">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-12 text-center">
            リブセラのここがすごい3つのPoint
          </h3>
          <div className="space-y-8 md:space-y-12">
            {/* Point 1 */}
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gold rounded-full flex-shrink-0">
                  <span className="text-white font-bold text-lg">01</span>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-dark-gray pt-3">
                  肌の再生力を強化
                </h4>
              </div>
              <p className="text-medium-gray leading-relaxed ml-0 md:ml-20 text-sm md:text-base">
                従来のフェイシャルトリートメントは、肌細胞が弱ったままのところに有効成分のある化粧品を使用しトリートメントをしていく表面的なトリートメント方法でした。リブセラは、プラズマを用いることで<span className="font-bold text-gold">肌細胞そのものを活性化</span>すると同時に防腐剤・無添加の有効成分が高いリバグロを併用することで、弱ってしまった細胞を元気にしお肌本来の再生力を引き上げてくれる根本から解決できるトリートメントになります。
              </p>
            </div>

            {/* Point 2 */}
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gold rounded-full flex-shrink-0">
                  <span className="text-white font-bold text-lg">02</span>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-dark-gray pt-3">
                  電位バランスの正常化
                </h4>
              </div>
              <p className="text-medium-gray leading-relaxed ml-0 md:ml-20 text-sm md:text-base">
                プラズマエネルギーがお肌の各細胞に作用し、様々な電位の分布バランスを正常に整えます。細胞内のエネルギー量が増えることで<span className="font-bold text-gold">肌の免疫力が強化</span>され、私たちの身体に本来備わっている自己治癒力を引き出すことで高いエイジングケア効果が期待できます。
              </p>
              <div className="mt-6 ml-0 md:ml-20 bg-beige rounded-2xl p-6">
                <p className="text-sm text-medium-gray leading-relaxed">
                  お肌の各細胞は膜電位を持っており、健康なお肌の細胞はプラス電位とマイナス電位がありバランスよく分布しています。しかし、肌のバリア機能が傷つくと電位の乱れが発生します。その結果細胞の老化が起こり肌にハリや弾力が無くなりお肌の老化につながります。
                </p>
              </div>
            </div>

            {/* Point 3 */}
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gold rounded-full flex-shrink-0">
                  <span className="text-white font-bold text-lg">03</span>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-dark-gray pt-3">
                  美容有効成分の深部浸透
                </h4>
              </div>
              <p className="text-medium-gray leading-relaxed ml-0 md:ml-20 text-sm md:text-base">
                プラズマを細胞レベルまで極微細化したことにより、細胞への刺激をいっさい与えることなく<span className="font-bold text-gold">有効成分の浸透効果だけを高める</span>ことが可能になりました。また、リブセラフェイシャルはお顔のお悩みだけでなく、男性女性の薄毛の悩みにもアプローチしていきます。
              </p>
            </div>
          </div>
        </div>

        {/* 専用美容液リバグロ */}
        <div className="mb-20 md:mb-28">
          <div className="bg-gradient-to-br from-beige to-light-gold rounded-3xl p-8 md:p-12">
            <div className="flex items-center justify-center gap-3 mb-6">
              <i className="ri-flask-fill text-3xl text-gold"></i>
              <h3 className="text-2xl md:text-3xl font-bold text-dark-gray">
                防腐剤完全0の専用美容液 Revergro（リバグロ）
              </h3>
            </div>
            <p className="text-medium-gray leading-relaxed text-center max-w-3xl mx-auto text-sm md:text-base">
              今までの化粧品は、お肌の状態に合わせた化粧品で足りないものを補うことが一般的であり根本的な改善には繋がりませんでした。しかし、その問題を解決したのが『Revergro EG moist rich serum』です。不足を補う「対処的コスメ」から根本的原因を追求した<span className="font-bold text-gold">「再生予防的コスメ」</span>それがリバグロです。
            </p>
          </div>
        </div>

        {/* フェイシャルトリートメント */}
        <div className="mb-20 md:mb-28">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-12 text-center">
            リブセラ フェイシャルトリートメント
          </h3>
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <h4 className="text-lg font-bold text-dark-gray mb-3 flex items-center gap-2">
                  <i className="ri-check-line text-gold text-xl"></i>
                  こんなお悩みに
                </h4>
                <ul className="space-y-2 text-sm md:text-base text-medium-gray">
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>シミ・くすみが気になる</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>シワ・たるみが目立つ</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>毛穴の開きが気になる</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>ニキビ跡を改善したい</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>肌のハリ・ツヤが欲しい</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">•</span>
                    <span>目元のケアをしたい</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <h4 className="text-lg font-bold text-dark-gray mb-3 flex items-center gap-2">
                  <i className="ri-time-line text-gold text-xl"></i>
                  施術の流れ
                </h4>
                <ol className="space-y-3 text-sm md:text-base text-medium-gray">
                  <li className="flex gap-3">
                    <span className="font-bold text-gold flex-shrink-0">1.</span>
                    <span>クレンジング・洗顔</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-gold flex-shrink-0">2.</span>
                    <span>専用美容液を塗布</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-gold flex-shrink-0">3.</span>
                    <span>エステティックプラズマをお顔に照射</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-gold flex-shrink-0">4.</span>
                    <span>パックなどで鎮静・整肌</span>
                  </li>
                </ol>
                <div className="mt-4 pt-4 border-t border-beige">
                  <p className="text-sm text-medium-gray">
                    <span className="font-bold text-dark-gray">施術時間：</span>約30分<br />
                    <span className="font-bold text-dark-gray">推奨頻度：</span>2週間に1回（1クール：3ヶ月間/6回）
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <h4 className="text-lg font-bold text-dark-gray mb-3 flex items-center gap-2">
                  <i className="ri-star-fill text-gold text-xl"></i>
                  3つのプローブで細かくアプローチ
                </h4>
                <div className="space-y-4 text-sm md:text-base text-medium-gray">
                  <div>
                    <p className="font-bold text-dark-gray mb-1">ポイントプローブ</p>
                    <p className="text-sm">まぶたの上や下まぶた、唇の上など細かい部分のトリートメントに最適</p>
                  </div>
                  <div>
                    <p className="font-bold text-dark-gray mb-1">ワイドプローブ</p>
                    <p className="text-sm">デコルテや頬まわりなど、広い面のトリートメントに適したプローブ</p>
                  </div>
                  <div>
                    <p className="font-bold text-dark-gray mb-1">Y字型プローブ</p>
                    <p className="text-sm">お肌や首筋、フェイスラインにフィットする形状で心地よいトリートメント</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gold/10 to-beige rounded-2xl p-6">
                <h4 className="text-lg font-bold text-dark-gray mb-3 flex items-center gap-2">
                  <i className="ri-shield-check-line text-gold text-xl"></i>
                  安心・安全なトリートメント
                </h4>
                <ul className="space-y-2 text-sm md:text-base text-medium-gray">
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">✓</span>
                    <span>痛みや熱さはほとんどありません</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">✓</span>
                    <span>ダウンタイムなし</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">✓</span>
                    <span>目元のデリケートな部分も施術可能</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gold mt-1">✓</span>
                    <span>金属アレルギーの方も対応可能</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* スカルプケア */}
        <div className="mb-20 md:mb-28">
          <h3 className="text-2xl md:text-3xl font-bold text-dark-gray mb-12 text-center">
            リブセラ スカルプケア
          </h3>
          <div className="bg-gradient-to-br from-beige to-light-gold rounded-3xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12">
              <div className="space-y-6">
                <p className="text-medium-gray leading-relaxed text-sm md:text-base">
                  頭皮環境を健やかに整えながら根元・毛髪の成長をサポートし、<span className="font-bold text-gold">ボリューム感のある髪</span>に導きます。
                </p>
                <p className="text-medium-gray leading-relaxed text-sm md:text-base">
                  頭皮のお悩みには色々なパターンがあり、頭皮をエステティックプラズマでアプローチすることでさらにアップデートできます。また、エッセンスや美容成分の浸透力が非常に優れているからこそ、多種多様な頭皮トラブルに対応することが可能になりました。
                </p>
                <div className="bg-white rounded-2xl p-6">
                  <h4 className="text-lg font-bold text-dark-gray mb-3">こんな方におすすめ</h4>
                  <ul className="space-y-2 text-sm md:text-base text-medium-gray">
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>抜け毛が増えた</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>トップのボリュームが欲しい</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>分け目が目立つようになった</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>産後の抜け毛が気になる</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>髪のハリ・コシがなくなった</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gold mt-1">•</span>
                      <span>頭皮環境を整えたい</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="space-y-6">
                <div className="bg-white rounded-2xl p-6">
                  <h4 className="text-lg font-bold text-dark-gray mb-3">MOUMITU併用で効果アップ</h4>
                  <p className="text-sm md:text-base text-medium-gray leading-relaxed mb-4">
                    スカルプトリートメントはリブセラとMOUMITU（高濃度活性化成長因子ヘッドスパ）の併用をおすすめしております。
                  </p>
                  <div className="space-y-2 text-sm text-medium-gray">
                    <p className="flex items-start gap-2">
                      <span className="text-gold mt-1">✓</span>
                      <span>頭皮の初期設定を整える</span>
                    </p>
                    <p className="flex items-start gap-2">
                      <span className="text-gold mt-1">✓</span>
                      <span>根元の初期設定を整える</span>
                    </p>
                    <p className="flex items-start gap-2">
                      <span className="text-gold mt-1">✓</span>
                      <span>芯からの初期設定を整える</span>
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6">
                  <h4 className="text-lg font-bold text-dark-gray mb-3">成長因子で頭皮環境を整える</h4>
                  <p className="text-sm md:text-base text-medium-gray leading-relaxed">
                    SCF・IGF-1・FGF・KGF-2・Noggin・VEGF・SOD1などの成長因子が頭皮環境を整え、根元からふんわりとしたハリ・コシのある髪へと導きます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* オゾンの危険性について */}
        <div className="mb-20 md:mb-28">
          <div className="bg-red-50 border-2 border-red-200 rounded-3xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">
              ⚠️ そのプラズマ機器は大丈夫ですか？
            </h3>
            <div className="space-y-6 text-medium-gray leading-relaxed">
              <div className="bg-white rounded-2xl p-6">
                <h4 className="text-lg font-bold text-dark-gray mb-3">オゾン優位ではありませんか？</h4>
                <p className="text-sm md:text-base mb-4">
                  特に美容複合機器で販売されているプラズマ機器は要注意です。プラズマとオゾンは片方を発生させるともう片方も発生するのが付き物。しかし、最近の機器は、オゾン優位のものがほぼ全てといっても過言ではありません。
                </p>
                <div className="bg-red-50 rounded-xl p-4">
                  <p className="text-sm font-bold text-red-600 mb-2">オゾンの危険性</p>
                  <ul className="space-y-1 text-sm text-medium-gray">
                    <li>• 息切れ・胸痛</li>
                    <li>• 喘息発作</li>
                    <li>• 肺がんリスク増加</li>
                    <li>• 美肌菌（黄色ブドウ球菌）が殺されてしまう</li>
                  </ul>
                </div>
              </div>

              <div className="bg-green-50 rounded-2xl p-6">
                <h4 className="text-lg font-bold text-green-600 mb-3 flex items-center gap-2">
                  <i className="ri-shield-check-fill text-2xl"></i>
                  リブセラは安心・安全
                </h4>
                <p className="text-sm md:text-base">
                  リブセラは、<span className="font-bold text-green-600">オゾンによる悪影響が全くありません</span>。安心してお客様へトリートメント提供が可能です。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ベストビューティーアイテム賞 */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-r from-gold to-yellow-600 text-white rounded-2xl px-8 py-4 shadow-lg">
            <p className="text-sm md:text-base font-semibold mb-1">安全性と有効性から</p>
            <p className="text-xl md:text-2xl font-bold">ベストビューティーアイテム賞</p>
            <p className="text-lg md:text-xl font-bold">3年連続受賞 殿堂入り</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RevcellaDetailSection;
